export default __webpack_public_path__ + "static/blob7-7dde824a2588c6aac8446e3ea6cf2ce4.svg";